export const asideDataEn = [
  {
    url: '/industries/financial-services',
    ownerDepartment: 'finance',
    description:
      'Hello,\n\nThank you for your interest in Andersen’s Financial Services. After you fill out this form, one of our team members will get in touch with you at the requested time to discuss your tech initiative.\n\nAndersen can’t wait to deliver the best results to you!',
  },
];

export const asideDataDe = [
  {
    url: '/industries/financial-services',
    ownerDepartment: 'finance',
    description:
      'Hallo,\n\nVielen Dank für Ihr Interesse an Finanzdienstleistungen von Andersen. Nachdem Sie dieses Formular ausgefüllt haben, wird sich eines unserer Teammitglieder zum gewünschten Zeitpunkt mit Ihnen in Verbindung setzen, um Ihre technische Initiative zu besprechen.\n\nAndersen kann es kaum erwarten, Ihnen die besten Ergebnisse zu liefern!',
  },
];

export const logos = {
  en: [
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-white.svg',
      alt: 'Samsung',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/verivox-white.svg',
      alt: 'Verivox',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/tui/tui-logo-white.svg',
      alt: 'TUI',
    },
  ],
  us: [
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-white.svg',
      alt: 'Samsung',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/asset_book.svg',
      alt: 'Asset Book',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/tigerconnect_white.svg',
      alt: 'Tiger Connect',
    },
  ],
  au: [
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-white.svg',
      alt: 'Samsung',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/frugl_white.svg',
      alt: 'Frugl',
    },
    {
      src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/korda_mentha.svg',
      alt: 'KordaMentha',
    },
  ],
};
